import React from 'react';
import { Text, fontWeightEnum, textVariantsEnum } from '@/components/Text';
import styles from './FormSectionCard.module.scss';

/**
 * Bordered card for one step of a multi-section form: an icon, an optional
 * step number, a title/description pair, then arbitrary field content.
 */
export const FormSectionCard = ({
  icon,
  iconBg,
  stepNumber,
  title,
  description,
  children,
}) => (
  <div className={styles.formSectionCard}>
    <div className={styles.formSectionHeader}>
      <span className={styles.iconWrap} style={{ backgroundColor: iconBg }}>
        {icon}
      </span>
      <div className={styles.headerText}>
        <Text
          variant={textVariantsEnum.Text_md}
          fontWeight={fontWeightEnum.Semibold}
        >
          {stepNumber ? `${stepNumber}. ${title}` : title}
        </Text>
        {description && (
          <Text
            variant={textVariantsEnum.Text_sm}
            fontWeight={fontWeightEnum.Normal}
            color="gray-600"
          >
            {description}
          </Text>
        )}
      </div>
    </div>
    <div className={styles.formSectionBody}>{children}</div>
  </div>
);
